export default "__VITE_ASSET__C_Y80McV__"